import { createSlice } from '@reduxjs/toolkit'

export const voucherSlice = createSlice({
  name: 'voucher',
  initialState: '',
  reducers: {
    updateVoucher: (state, action) => {
      return action.payload;
    },
  },
})

export const { updateVoucher } = voucherSlice.actions;

export default voucherSlice.reducer;
